import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AuthenticationService } from './authentication/authentication.service';

@Component({
    selector: 'vc-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnInit {

  logo: string;
  clientDetails;

  constructor(
    private readonly title: Title,
    private swUpdate: SwUpdate,
    private readonly authenticationService: AuthenticationService,
    private readonly renderer: Renderer2
  ) {
    this.title.setTitle('Sign In');
  }

  ngOnInit() {
    this.changeMastery();
    if (!environment.enableCtrl) {
      this.disableControls();
    }

  if (this.swUpdate.isEnabled) {
    console.log("Serviceworker update enabled ");
    this.swUpdate.versionUpdates.subscribe((upd) => {
      console.log("SW Update Event", upd);

      if (upd.type === 'VERSION_DETECTED') {
        console.log("New version detected");
      }

      if (upd.type === 'VERSION_READY') {
        console.log("New version available");

        this.swUpdate.activateUpdate().then(() => {
          console.info("received update and activated");
          window.location.reload();
        });
      }
      if (upd.type === 'VERSION_INSTALLATION_FAILED') {
        console.error("Version installation failed");
      }
    }, (error) => {
      console.error(error);
    });

    this.swUpdate.checkForUpdate().then(() => {
      console.log("Got new Version");
    }).catch((error) => {
      console.error('Could not check for app updates', error);
    });
    this.applyUserway();
  }
  this.authenticationService.getClientDetails().subscribe(data => {
    this.clientDetails = data;
    localStorage.setItem('clientId', this.clientDetails.id);
    localStorage.setItem('logoPath', this.clientDetails.logoPath);
    localStorage.setItem('ApplicationID',this.clientDetails.appId);
    localStorage.setItem('moodleUrl',this.clientDetails.moodleUrl);
    localStorage.setItem('isSelfRegisterAllowed',this.clientDetails.isSelfRegisterAllowed);
    document.documentElement.style.setProperty('--primary-color', this.clientDetails.primaryAppColour);
    document.documentElement.style.setProperty('--secondary-color', this.clientDetails.secondaryAppColour);
  });

  this.authenticationService.currentLogo.subscribe(logo => {
    this.logo = logo + localStorage.getItem('logoPath');
  });
}

  disableControls() {

    function keyPressCheck(event) {
      if (event.keyCode === 123) {
        return false;
      }
    }

    document.oncontextmenu = function () {
      return false;
    }

    function disableCtrlKeyCombination(e) {
      //list all CTRL + key combinations you want to disable
      const forbiddenKeys = new Array('a', 'n', 'c', 'x', 'v', 'j', 'w');
      let key, isCtrl;

      if (window.event) {
        key = (<any>window.event).keyCode; //IE
        if ((<any>window.event).ctrlKey) {
          isCtrl = true;
        } else {
          isCtrl = false;
        }
      } else {
        key = e.which; //firefox
        if (e.ctrlKey) {
          isCtrl = true;
        } else {
          isCtrl = false;
        }
      }
      //if ctrl is pressed check if other key is in forbidenKeys array
      if (isCtrl) {
        for (let i = 0; i < forbiddenKeys.length; i++) {
          //case-insensitive comparation
          if (forbiddenKeys[i].toLowerCase() === String.fromCharCode(key).toLowerCase()) {
            return false;
          }
        }
      }
      return true;
    }
  }

  applyUserway() {
    let url = window.location.href;
    if(url.includes('test.captr')){
      this.renderer.addClass(document.body, 'userway');
    } else if (url.includes('mnprt') ){
      this.renderer.addClass(document.body, 'aladdin-app');
    }
  }
  
  changeMastery() {
    let url = window.location.href;
    if(url.includes('masterypath')){
      console.log("identifier1111");
      this.renderer.addClass(document.body, 'customStyle');
    }
  }

}
